import request from '@/router/axios';

export const getYgdaList = (current, size, params) => {
  return request({
    url: '/api/cube-agent/userrecord/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
};
//没有数据权限
export const getYgdaListall = (current, size, params) => {
  return request({
    url: '/api/cube-agent/userrecord/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
};

export const getDetail = (id) => {
  return request({
    url: '/api/cube-agent/userrecord/detail',
    method: 'get',
    params: {
      id
    }
  })
};
export const getDetailByAdminId = (adminId) => {
  return request({
    url: '/api/cube-agent/userrecord/detail',
    method: 'get',
    params: {
      adminId
    }
  })
};

export const remove = (ids) => {
  return request({
    url: '/api/cube-agent/userrecord/remove',
    method: 'post',
    params: {
      ids,
    }
  })
};

export const add = (row) => {
  return request({
    url: '/api/cube-agent/userrecord/submit',
    method: 'post',
    data: row
  })
};

export const grzxtxAdd = (data) => {
  return request({
    url: '/api/cube-agent/userrecord/submit',
    method: 'post',
    data: data
  })
};

export const update = (row) => {
  return request({
    url: '/api/cube-agent/userrecord/submit',
    method: 'post',
    data: row
  })
};

export const getJS = (current, size, params) => {
  return request({
    url: '/api/cube-agent/magiccubefiverisks/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
};

export const getGW = (current, size, params) => {
  return request({
    url: '/api/cube-system/post/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
};

export const getGWGZ = (current, size, params) => {
  return request({
    url: '/api/cube-agent/post/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
};

export const getgwlist = (params) => {
  return request({
    url: '/api/cube-agent/rzgzbl/getgwlist',
    method: 'get',
    params: {
      ...params,
    }
  })
};

export const getXzjlData = (current, size, params) => {
  return request({
    url: '/api/cube-agent/rzygxzbdb/list',
    method: 'get',
    params: {
      current, size, ...params
    }
  })
};

export const getXzjlDataPage = (current, size, params) => {
  return request({
    url: '/api/cube-agent/rzygxzbdb/page',
    method: 'get',
    params: {
      current, size, ...params
    }
  })
};

export const getZzmm = (da_zzmm) => {
  return request({
    url: `/api/cube-system/dict/dictionary?code=${da_zzmm}`,
    method: 'get'
  })
};

export const getXl = (da_xl) => {
  return request({
    url: `/api/cube-system/dict/dictionary?code=${da_xl}`,
    method: 'get'
  })
};

export const exportApi = "/api/cube-agent/rzyggzmx/getgzddc";
